module.exports = __webpack_public_path__ + "img/features-3.3807e83b.png";